import { CategoryItemType } from 'types/categoryTypes';

const findCategory = (headerMenu: any, name: string): CategoryItemType[] => {
  const found: void | { data: CategoryItemType[] } = headerMenu.menu
    .concat(headerMenu.basicMenu)
    .find((item: { name: string }) => item.name === name);

  return found === undefined ? [] : found.data;
};

const findPageTitle = (list: CategoryItemType[], name: string): string => {
  const found: void | CategoryItemType = list.find((item: { path: string }) => item.path === name);

  return found === undefined ? '' : found.name;
};

const download = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
}

const downloadStream = (
  url: string,
  fileName: string,
  params: object
): Promise<boolean> => new Promise(resolve => fetch(url, {
  body: JSON.stringify(params),
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  },
  method: 'POST'
})
  .then(response => response.blob())
  .then(blob => {
    const anchor = document.createElement('a');
    anchor.download = fileName;
    anchor.href = window.URL.createObjectURL(blob);
    anchor.click();
    resolve(true);
  }));

export { findCategory, findPageTitle, download, downloadStream };
